export default "__VITE_ASSET__DFtPYc6E__"